function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M480-120L345-75q-7 2-13 3t-12 1q-32 0-56-22.5T240-151v-218L136-538q-6-10-9-20.5t-3-21.5q0-11 3-21.5t9-20.5l136-220q11-18 29-28t39-10h280q21 0 39 10t29 28l136 220q6 10 9 20.5t3 21.5q0 11-3 21.5t-9 20.5L720-369v218q0 35-24 57.5T640-71q-6 0-12-1t-13-3l-135-45zm0-84l160 53v-129H320v129l160-53zM340-360h280l136-220-136-220H340L204-580l136 220zm98-170l141-142q11-12 27.5-11.5T635-672q12 12 12.5 28.5T636-615L466-445q-12 12-28 12t-28-12l-85-85q-12-12-12-28.5t12-28.5q12-12 28.5-12t28.5 12l56 57zm42 250H320h320-160z"
  }));
};
const SvgRibbon = styled(BaseComponent).withConfig({
  displayName: "Ribbon__SvgRibbon",
  componentId: "sc-qn6qiu-0"
})(["outline:none;"]);
SvgRibbon.isIcon = true;
export default SvgRibbon;